import React, { useEffect, useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import CorePassword from "../../core/inputs/CorePassword";
import CoreTextButton from "../../core/inputs/CoreTextButton";
import { setNextUrl } from "../../store/actions/routeActions";
import { setAuthReducer } from "../../store/actions/authActions";
import { api_request } from "../../store/actions/commonAction";
import {
  adminMfaEnabled,
  API_METHOD_POST,
  systemAdmin,
} from "../../config/constants";
import {
  AUTH_LOADING,
  LOGIN_ERROR,
  LOGIN_SUCCESS,
} from "../../store/types/authTypes";
import AuthContainer from "./AuthContainer";
import CoreButtonContainer from "../../core/layouts/CoreButtonContainer";
import CoreContainedButton from "../../core/inputs/CoreContainedButton";
import { theme } from "../../config/theme";
import CoreH6 from "../../core/dataDisplay/CoreH6";
import CoreTypographySubtitle2 from "../../core/dataDisplay/CoreTypographySubtitle2";
import { Box } from "@mui/material";
import { Formik } from "formik";
import {
  loginWithMfaSchema,
  passwordSchema,
} from "../../formSchemas/authSchemas";
import CoreOtpInput from "../../core/inputs/CoreOtpInput";
import {
  OTP_SENT_ERROR,
  OTP_SENT_SUCCESS,
} from "../../store/types/communicationTypes";
import CoreCaptcha from "../../core/inputs/CoreCaptcha";

export default function GetPassword() {
  const dispatch = useDispatch();
  const captchaRef = useRef()

  const [password, setPassword] = useState(null);
  const [otp, setOtp] = useState(null);
  const [captchaToken, setCaptchaToken] = useState("");

  const chechUserExistData = useSelector(
    (state) => state?.auth?.chechUserExistData
  );
  const emailOrPhone = useSelector((state) => state?.auth?.emailOrPhone);
  const uid = useSelector((state) => state?.auth?.uid);
  const authError = useSelector((state) => state?.auth?.authError);
  const appSettings = useSelector((state) => state?.common?.appSettings);
  const adminMfaInDb = appSettings?.find((set) => set.name === adminMfaEnabled)

  const adminMfa = adminMfaInDb
    ? adminMfaInDb?.value?.enabled
    : true;

  const otpLogin = chechUserExistData?.role === systemAdmin && adminMfa;

  useEffect(() => {
    if (adminMfa && otpLogin) {
      sentOtp();
    }
  }, [adminMfa, otpLogin]);

  const sentOtp = (e) => {
    e?.preventDefault();
    dispatch(
      api_request(
        API_METHOD_POST,
        "/sentOtp",
        { data: emailOrPhone },
        null,
        null,
        OTP_SENT_SUCCESS,
        OTP_SENT_ERROR,
        false,
        false
      )
    );
  };

  useEffect(() => {
    if (uid) {
      dispatch(setNextUrl("/dashboard"));
    }
    if (authError) {
      alert(authError);
      dispatch(setAuthReducer({ authError: null }));
      captchaRef?.current?.reset()
    }
  }, [uid, authError]);

  const backToMail = (e) => {
    e.preventDefault();
    dispatch(setNextUrl("/check/user"));
    dispatch(
      setAuthReducer({
        chechUserExistData: null,
        chechUserExistSuccess: false,
        chechUserExistError: false,
      })
    );
  };

  const login = (e) => {
    e?.preventDefault();
    dispatch(
      api_request(
        API_METHOD_POST,
        otpLogin ? "/loginWithOtp" : "/login",
        otpLogin
          ? {
              emailOrPhone: emailOrPhone,
              password: password,
              otp: otp,
              captchaToken: captchaToken,
            }
          : {
              emailOrPhone: emailOrPhone,
              password: password,
              captchaToken: captchaToken,
            },
        {},
        AUTH_LOADING,
        LOGIN_SUCCESS,
        LOGIN_ERROR,
        false,
        false
      )
    );
  };

  const forgotPassword = (e) => {
    e.preventDefault();
    dispatch(setNextUrl("/login/otp"));
  };

  return (
    <AuthContainer>
      {/* <CoreAvatar
        src={chechUserExistData?.photoUrl}
        style={{ width: 80, height: 80 }}
      /> */}
      <CoreTypographySubtitle2 style={{ textAlign: "center" }}>
        {emailOrPhone || "EMAIL NOT FOUND"}
      </CoreTypographySubtitle2>
      {chechUserExistData?.name && (
        <CoreH6
          style={{ fontWeight: "bold", color: theme?.palette?.primary?.main }}
        >
          {chechUserExistData?.name || "NA"}
        </CoreH6>
      )}
      <CoreTextButton onClick={backToMail}>Not You?</CoreTextButton>
      <form onSubmit={login} style={{ width: "100%" }}>
        <Formik
          initialValues={
            !otpLogin
              ? { password: "", captchaToken: "" }
              : { password: "", myotp: "", captchaToken: "" }
          }
          validationSchema={otpLogin ? loginWithMfaSchema : passwordSchema}
          onSubmit={(values, actions) => {
            login();
          }}
        >
          {(formikProps) => (
            <>
              {otpLogin && (
                <CoreOtpInput
                  id="myotp"
                  onBlur={formikProps.handleBlur("myotp")}
                  onChange={(value) => {
                    setOtp(value);
                    formikProps.setFieldValue("myotp", value);
                  }}
                  value={formikProps.values.myotp}
                  formikProps={formikProps}
                  autoFocus={true}
                  label="Enter OTP"
                />
              )}
              <CorePassword
                id="password"
                onBlur={formikProps.handleBlur("password")}
                onChange={(e) => {
                  setPassword(e.target.value);
                  formikProps.handleChange(e);
                }}
                value={formikProps.values.password}
                formikProps={formikProps}
                autoFocus={true}
                label="Enter password"
              />
              <CoreCaptcha
                id="captchaToken"
                onChange={(val) => {
                  if (val) {
                    formikProps.setFieldValue("captchaToken", val);
                    setCaptchaToken(val);
                  }
                }}
                formikProps={formikProps}
                captchaRef={captchaRef}
              />
              <CoreButtonContainer style={{ justifyContent: "center" }}>
                <CoreContainedButton
                  fullWidth={true}
                  type="submit"
                  onClick={formikProps.handleSubmit}
                >
                  Login
                </CoreContainedButton>
              </CoreButtonContainer>
            </>
          )}
        </Formik>
      </form>
      <Box style={{ display: "flex", justifyContent: "center" }}>
        <CoreContainedButton variant="text" onClick={forgotPassword}>
          Forgot password?
        </CoreContainedButton>
      </Box>
    </AuthContainer>
  );
}
